import { config } from '../config/config';

const apiHeaders = () => {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('AUTH-KEY', config.addressLookupConfig.apiKey);
    return headers;
};

export default apiHeaders;
